import { useAccounts } from '../../../../fetchHooks/useAccount';
import { isValidAccountTransferFrom } from '../../../../services/accountFilters';

const useCanMakeDownpayment = () => {
    const { data: accounts, isLoading, isError } = useAccounts();
    const transferFrom = accounts?.filter(isValidAccountTransferFrom);
    const canMakeDownpayment = transferFrom?.length && transferFrom.length > 0;
    return { canMakeDownpayment, isLoading, isError };
};

export default useCanMakeDownpayment;
